// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"521":"fc8e3d9bd24d220f5ef0","534":"2f9e46c4624aabe926d5","657":"fb8321a13fd89205dba6","700":"31aa7e1eac08947f692e","916":"6ac8210da3dd67e2678a","928":"f0bacaa0dd86939d3f75","938":"79b6483566ad3ebf938e"}[chunkId] + ".js";
};